import { render, staticRenderFns } from "./create-or-edit-blogs.vue?vue&type=template&id=09f83e1c&scoped=true&"
import script from "./create-or-edit-blogs.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-blogs.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit-blogs.vue?vue&type=style&index=0&id=09f83e1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f83e1c",
  null
  
)

export default component.exports